import React from 'react';

import formatToUSD from '../utils/formatUsd';

export default function RepaymentDetails(props: {
  repaymentDetails: RepaymentDetail[]
}) {
  return (
    <div className="grow md:flex h-[100%] md:w-full overflow-y-auto">
      <table className="grow divide-y divide-gray-300">
        <thead className="sticky top-0 bg-white">
          <tr>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">
              Payment #
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
              Beginning Balance
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
              Monthly Payment
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
              Principal
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
              Interest
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 text-sm text-gray-900">
              Ending Balance
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {props.repaymentDetails.map((detail) => (
            <tr key={`payment-detail-${detail.paymentNumber}`} className="even:bg-gray-50">
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-600">
                {detail.paymentNumber}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                {formatToUSD(detail.beginningBalance)}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                {formatToUSD(detail.monthlyPayment)}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                {formatToUSD(detail.principalPayment)}
              </td>
              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                {formatToUSD(detail.interestPayment)}
              </td>
              <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium text-gray-600">
                {formatToUSD(detail.endingBalance)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}